import {stopPropagation} from '@dvrd/dvr-controls';

import './style/bolmateCollapsibleSection.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {PropsWithChildren, ReactNode, useState} from 'react';

import {BolmateCollapsibleSectionSize} from '../../../util/types';

interface Props {
    title: string;
    icon?: string;
    size?: BolmateCollapsibleSectionSize;
    defaultOpen?: boolean;
    open?: boolean;
    onToggle?: (open: boolean, evt: React.MouseEvent) => void;
    rightContent?: ReactNode;
    children: ReactNode;
    className?: string;
}

export default function BolmateCollapsibleSection(props: PropsWithChildren<Props>) {
    const {title, icon, size = 'normal', defaultOpen = true, rightContent, children, className} = props;
    const [internalOpen, setInternalOpen] = useState(defaultOpen);

    const isControlled = props.open !== undefined;
    const isOpen = isControlled ? props.open! : internalOpen;

    function handleToggle(event: React.MouseEvent) {
        const next = !isOpen;
        if (isControlled) {
            props.onToggle?.(next, event);
        } else {
            setInternalOpen(next);
        }
    }

    return (
        <div className={classNames('bolmate-collapsible-section', `size-${size}`, isOpen && 'open', className)}>
            <div className='bolmate-collapsible-header' onClick={handleToggle}>
                <div className='bolmate-collapsible-header-left'>
                    {icon && <Icon icon={icon} className='bolmate-collapsible-icon' />}
                    <span className='bolmate-collapsible-title'>{title}</span>
                    <Icon icon='mdi:chevron-down' className='bolmate-collapsible-chevron' />
                </div>
                {rightContent && (
                    <div className='bolmate-collapsible-header-right' onClick={stopPropagation}>
                        {rightContent}
                    </div>
                )}
            </div>
            {isOpen && <div className='bolmate-collapsible-content'>{children}</div>}
        </div>
    );
}
